import { render, staticRenderFns } from "./SettingAppSetting.vue?vue&type=template&id=127e5ea6&"
import script from "./SettingAppSetting.vue?vue&type=script&lang=js&"
export * from "./SettingAppSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports